import { render, staticRenderFns } from "./WishlistSidebar.vue?vue&type=template&id=03b488d2&scoped=true&"
import script from "./WishlistSidebar.vue?vue&type=script&lang=ts&"
export * from "./WishlistSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./WishlistSidebar.vue?vue&type=style&index=0&id=03b488d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b488d2",
  null
  
)

export default component.exports